import React from 'react';
import Transition from 'react-transition-group/Transition';



export class BasicAnimation extends React.Component {

  constructor(props) {
    super(props);

    if(!this.props.duration) {
      this.duration = 300;
    } else {
      this.duration = this.props.duration;
    }

    if(!this.props.delay) {
      this.delay = 0;
    } else {
      this.delay = this.props.delay;
    }

    this.defaultStyle = {
      transition: `opacity ${this.duration}ms ease-in-out ${this.delay}ms`,
      opacity: 0
    };

    this.transitionStyles = {
      entering: {
        opacity: 0
      },
      entered:  {
        opacity: 1
      },
      exiting: {
        opacity: 1
      },
      exited: {
        opacity: 0
      }
    };

    this.state = {
      isShown: false
    };
  }

  componentDidMount(){
    this.setState({
      isShown: true
    })
  }

  componentWillUnmount(){
    this.setState({
      isShown: false
    })
  }

  render() {
    if (!this.props.children) {
      return null;
    }

    return(
      <Transition in={this.state.isShown} enter={true} exit={true} appear={true} timeout={this.duration}>
        {(state) => (
          <div style={{
                  ...this.defaultStyle,
                  ...this.transitionStyles[state]
                }}
               className={"transition-container"}>
            {this.props.children}
          </div>
        )}
      </Transition>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/animations/BasicAnimation.js